(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery-2"] && !Shopify.designMode) return;
  try {
    class ImageGallery {
    constructor(thumbsSelector, featuredImageWrapper) {
      this.thumbs = thumbsSelector;
      this.imageWrapper = featuredImageWrapper;
      this.mainImage = featuredImageWrapper?.querySelector('.product-gallery__image');
      this.imagesContainer = this.mainImage?.parentElement;
      this.currentIndex = 0;
      this.galleryImages = [];
      this.zoomLevel = 2;
      this.lensSize = 400;
      this.thumbsContainer = this.thumbs?.[0]?.parentElement || null;
      this.thumbDragState = {
        active: false,
        dragging: false,
        moved: false,
        startY: 0,
        startX: 0,
        startScrollLeft: 0,
        pointerId: null,
      };
      this.thumbDragThreshold = 14;
      this.thumbClickSuppressed = false;
      this.init();
    }
    
    init() {
      // Store all product images data from thumbnails
      this.galleryImages = Array.from(this.thumbs).map((thumb, index) => ({
        index,
        variantId: thumb.dataset.variantId,
        thumb,
        baseImageUrl: this.extractBaseImageUrl(thumb.src)
      }));

      // Set initial active thumb
      const activeThumb = Array.from(this.thumbs).find(t => t.classList.contains('active'));
      this.currentIndex = activeThumb ? Array.from(this.thumbs).indexOf(activeThumb) : 0;

      // Update main image on initial load
      this.updateMainImage(this.currentIndex, false);

      // Setup lens element - find from parent gallery
      const gallery = document.querySelector('.product-main__gallery');
      this.lens = gallery?.querySelector('.product-gallery__lens');
      this.setupLensListeners();

      // Listen to variant change
      this.onVariantChange('product-variant:changed');

      // Add click listeners to thumbnails
      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', (e) => {
          if (this.thumbClickSuppressed) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          this.onThumbClick(index);
        });
      });

      this.setupThumbDrag();

      this.prevButton = document.querySelector('.product-gallery__nav--prev');
      this.nextButton = document.querySelector('.product-gallery__nav--next');

      this.setupNavigation();
    }

    extractBaseImageUrl(imageUrl) {
      // Remove width parameter from image URL to get base URL
      return imageUrl.split('?')[0].replace(/(_\d+x\d+)?\./, '.');
    }

    generateSrcset(baseImageUrl, widths) {
      // Generate srcset with specified widths for main image
      return widths.map(w => {
        const url = baseImageUrl.includes('?') 
          ? baseImageUrl + `&width=${w}&crop=center` 
          : baseImageUrl + `?width=${w}&crop=center`;
        return `${url} ${w}w`;
      }).join(', ');
    }

    onThumbClick(index) {
      if (index === this.currentIndex) return;
      this.currentIndex = index;
      this.updateMainImage(index);
      this.updateThumbnailActive(index);
      this.scrollToThumb(index);
    }

    setupThumbDrag() {
      if (!this.thumbsContainer) return;

      this.thumbsContainer.addEventListener('pointerdown', (e) => this.onThumbDragStart(e));
      this.thumbsContainer.addEventListener('pointermove', (e) => this.onThumbDragMove(e));
      this.thumbsContainer.addEventListener('pointerup', (e) => this.onThumbDragEnd(e));
      this.thumbsContainer.addEventListener('pointercancel', (e) => this.onThumbDragEnd(e));
      this.thumbsContainer.addEventListener('lostpointercapture', () => this.onThumbDragEnd());
    }

    onThumbDragStart(e) {
      if (!this.thumbsContainer || e.button !== 0) return;

      this.thumbDragState.active = true;
      this.thumbDragState.dragging = false;
      this.thumbDragState.moved = false;
      this.thumbDragState.startX = e.clientX;
      this.thumbDragState.startY = e.clientY;
      this.thumbDragState.startScrollLeft = this.thumbsContainer.scrollLeft;
      this.thumbDragState.pointerId = e.pointerId;
    }

    onThumbDragMove(e) {
      if (!this.thumbDragState.active || !this.thumbsContainer) return;

      const deltaX = e.clientX - this.thumbDragState.startX;
      const deltaY = e.clientY - this.thumbDragState.startY;

      if (Math.abs(deltaX) > this.thumbDragThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        this.thumbDragState.moved = true;
        if (!this.thumbDragState.dragging) {
          this.thumbDragState.dragging = true;
          this.thumbsContainer.classList.add('dragging');
          this.thumbClickSuppressed = true;
          this.thumbsContainer.setPointerCapture?.(e.pointerId);
        }
      }

      if (!this.thumbDragState.dragging) return;

      e.preventDefault();
      this.thumbsContainer.scrollLeft = this.thumbDragState.startScrollLeft - deltaX;
    }

    onThumbDragEnd(e) {
      if (!this.thumbsContainer) return;

      const wasDragging = this.thumbDragState.moved;
      this.thumbDragState.active = false;
      this.thumbDragState.dragging = false;
      this.thumbsContainer.classList.remove('dragging');

      if (this.thumbDragState.pointerId !== null && this.thumbsContainer.hasPointerCapture?.(this.thumbDragState.pointerId)) {
        this.thumbsContainer.releasePointerCapture?.(this.thumbDragState.pointerId);
      }
      this.thumbDragState.pointerId = null;

      this.thumbDragState.moved = false;

      if (wasDragging) {
        setTimeout(() => {
          this.thumbClickSuppressed = false;
        }, 50);
      } else {
        this.thumbClickSuppressed = false;
      }
    }

    setupLensListeners() {
      if (!this.lens || !this.mainImage || !this.imagesContainer) return;

      this.lens.style.width = `${this.lensSize}px`;
      this.lens.style.height = `${this.lensSize}px`;

      this.imagesContainer.addEventListener('mouseenter', (e) => this.handleLensMouseOver(e));
      this.imagesContainer.addEventListener('mousemove', (e) => this.handleLensMouseMove(e));
      this.imagesContainer.addEventListener('mouseleave', () => this.handleLensMouseOut());
    }

    handleLensMouseOver(e) {
      if (!this.lens) return;
      this.lens.classList.add('active');
      if (e) {
        this.handleLensMouseMove(e);
      }
    }

    handleLensMouseMove(e) {
      if (!this.lens || !this.mainImage) return;

      const imgElement = this.mainImage.querySelector('img');
      const figureRect = this.mainImage.getBoundingClientRect();
      const imgRect = imgElement?.getBoundingClientRect() || figureRect;
      const renderedImageRect = this.getRenderedImageRect(imgElement, figureRect) || imgRect;
      const x = e.clientX - renderedImageRect.left;
      const y = e.clientY - renderedImageRect.top;

      // Ensure mouse is within image bounds
      if (x < 0 || y < 0 || x > renderedImageRect.width || y > renderedImageRect.height) return;

      // Set background image and position
      if (imgElement) {
        const lensImageUrl = this.getLensImageUrl(imgElement);
        const bgWidth = renderedImageRect.width * this.zoomLevel;
        const bgHeight = renderedImageRect.height * this.zoomLevel;

        this.lens.style.backgroundImage = `url("${lensImageUrl}")`;
        this.lens.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;

        const bgX = Math.min(0, Math.max(this.lensSize - bgWidth, (this.lensSize / 2) - (x * this.zoomLevel)));
        const bgY = Math.min(0, Math.max(this.lensSize - bgHeight, (this.lensSize / 2) - (y * this.zoomLevel)));

        this.lens.style.backgroundPosition = `${Math.round(bgX)}px ${Math.round(bgY)}px`;
      }

      // Update hover overlay position on image
      const overlay = this.mainImage.querySelector('.product-gallery__hover-overlay');
      if (overlay) {
        // Overlay size is 1/zoomLevel of lens size on the actual image
        const overlaySize = this.lensSize / this.zoomLevel;
        const imageOffsetX = renderedImageRect.left - figureRect.left;
        const imageOffsetY = renderedImageRect.top - figureRect.top;
        
        // Position overlay centered on cursor
        const overlayX = imageOffsetX + x - (overlaySize / 2);
        const overlayY = imageOffsetY + y - (overlaySize / 2);
        
        // Constrain to image bounds
        const constrainedX = Math.max(imageOffsetX, Math.min(overlayX, imageOffsetX + renderedImageRect.width - overlaySize));
        const constrainedY = Math.max(imageOffsetY, Math.min(overlayY, imageOffsetY + renderedImageRect.height - overlaySize));
        
        overlay.style.width = overlaySize + 'px';
        overlay.style.height = overlaySize + 'px';
        overlay.style.left = constrainedX + 'px';
        overlay.style.top = constrainedY + 'px';
      }
    }

    getRenderedImageRect(imgElement, figureRect) {
      if (!imgElement || !figureRect) return null;

      const naturalWidth = imgElement.naturalWidth;
      const naturalHeight = imgElement.naturalHeight;
      if (!naturalWidth || !naturalHeight) return null;

      const figureRatio = figureRect.width / figureRect.height;
      const imageRatio = naturalWidth / naturalHeight;

      let renderedWidth = figureRect.width;
      let renderedHeight = figureRect.height;
      let offsetX = 0;
      let offsetY = 0;

      if (imageRatio > figureRatio) {
        renderedHeight = figureRect.width / imageRatio;
        offsetY = (figureRect.height - renderedHeight) / 2;
      } else {
        renderedWidth = figureRect.height * imageRatio;
        offsetX = (figureRect.width - renderedWidth) / 2;
      }

      return {
        left: figureRect.left + offsetX,
        top: figureRect.top + offsetY,
        width: renderedWidth,
        height: renderedHeight,
      };
    }

    handleLensMouseOut() {
      if (!this.lens) return;
      this.lens.classList.remove('active');
    }

    getLensImageUrl(imgElement) {
      const sourceUrl = imgElement?.currentSrc || imgElement?.src || '';
      if (!sourceUrl) return '';

      if (sourceUrl.includes('?width=')) {
        return sourceUrl.replace(/\?width=\d+/, '?width=1206');
      }

      if (sourceUrl.includes('?')) {
        return `${sourceUrl}&width=1206&crop=center`;
      }

      return `${sourceUrl}?width=1206&crop=center`;
    }

    updateMainImage(index, animate = true) {
      if (!this.mainImage) return;
      const imageData = this.galleryImages[index];
      if (!imageData) return;

      const mainWidths = [448, 600, 768, 800, 960, 1024, 1206];
      const newSrc = imageData.baseImageUrl + '?width=615&crop=center';
      const newSrcset = this.generateSrcset(imageData.baseImageUrl, mainWidths);

      if (animate) {
        // Fade out
        this.mainImage.classList.add('fade-out');
        
        setTimeout(() => {
          const mainImg = this.mainImage.querySelector('img');
          const thumbImg = imageData.thumb;
          
          if (mainImg && thumbImg) {
            // Update src and srcset
            mainImg.src = newSrc;
            mainImg.srcset = newSrcset;
            mainImg.alt = thumbImg.alt;
            mainImg.title = thumbImg.title;

            // Wait for image to load before fade in
            const loadHandler = () => {
              this.mainImage.classList.remove('fade-out');
              mainImg.removeEventListener('load', loadHandler);
              mainImg.removeEventListener('error', errorHandler);
            };

            const errorHandler = () => {
              // If image fails to load, still fade in after 1s
              setTimeout(() => {
                this.mainImage.classList.remove('fade-out');
              }, 1000);
              mainImg.removeEventListener('load', loadHandler);
              mainImg.removeEventListener('error', errorHandler);
            };

            // If image is already cached, load event might fire immediately
            if (mainImg.complete) {
              this.mainImage.classList.remove('fade-out');
            } else {
              mainImg.addEventListener('load', loadHandler, { once: true });
              mainImg.addEventListener('error', errorHandler, { once: true });
            }
          }
        }, 200);
      } else {
        // Initial load without animation
        const mainImg = this.mainImage.querySelector('img');
        const thumbImg = imageData.thumb;
        
        if (mainImg && thumbImg) {
          mainImg.src = newSrc;
          mainImg.srcset = newSrcset;
          mainImg.alt = thumbImg.alt;
          mainImg.title = thumbImg.title;
        }
      }
    }

    updateThumbnailActive(index) {
      this.thumbs.forEach((t) => t.classList.remove('active'));
      if (this.thumbs[index]) {
        this.thumbs[index].classList.add('active');
      }
    }

    onVariantChange(eventName) {
      document.addEventListener(eventName, (event) => {
        const targetThumb = Array.from(this.thumbs).find(thumb => 
          thumb.dataset.variantId == event.detail.id
        );
        if (targetThumb) {
          const targetIndex = Array.from(this.thumbs).indexOf(targetThumb);
          if (targetIndex !== -1 && targetIndex !== this.currentIndex) {
            this.onThumbClick(targetIndex);
          }
        }
      });
    }

    scrollToThumb(index) {
      const thumb = this.thumbs[index];
      const thumbsContainer = thumb?.parentElement;
      
      if (thumb && thumbsContainer) {
        const thumbRect = thumb.getBoundingClientRect();
        const containerRect = thumbsContainer.getBoundingClientRect();
        const thumbCenter = thumbRect.left + thumbRect.width / 2;
        const containerCenter = containerRect.left + containerRect.width / 2;
        const scrollOffset = thumbCenter - containerCenter;
        
        thumbsContainer.scrollTo({
          left: thumbsContainer.scrollLeft + scrollOffset,
          behavior: 'smooth'
        });
      }
    }

    setupNavigation() {
      if (!this.prevButton || !this.nextButton) return;

      this.prevButton.addEventListener('click', () => {
        this.goPrevious();
      });

      this.nextButton.addEventListener('click', () => {
        this.goNext();
      });
    }

    goPrevious() {
      const total = this.galleryImages.length;

      const index =
        this.currentIndex === 0
          ? total - 1
          : this.currentIndex - 1;

      this.onThumbClick(index);
    }

    goNext() {
      const total = this.galleryImages.length;

      const index =
        this.currentIndex === total - 1
          ? 0
          : this.currentIndex + 1;

      this.onThumbClick(index);
    }
  }

  class StockBadgeUI {
    constructor() {
      this.wrapper = document.querySelector('[data-stock-badge="in"]')?.closest('.product-main__flair-badge');
      this.inStockBadge = this.wrapper?.querySelector('[data-stock-badge="in"]');
      this.outStockBadge = this.wrapper?.querySelector('[data-stock-badge="out"]');

      this.update = this.update.bind(this);
      this.init();
    }

    init() {
      if (!this.wrapper) return;

      document.addEventListener('product-variant:changed', this.update);
    }

    toggleElement(element, isVisible) {
      if (!element) return;

      element.hidden = !isVisible;
      if (isVisible) {
        element.removeAttribute('aria-hidden');
      } else {
        element.setAttribute('aria-hidden', 'true');
      }
    }

    update(event) {
      const variant = event?.detail;
      if (!variant || !this.wrapper) return;

      const isAvailable = Boolean(variant.available);

      this.toggleElement(this.inStockBadge, isAvailable);
      this.toggleElement(this.outStockBadge, !isAvailable);
    }
  }

  document.addEventListener('DOMContentLoaded', async function () {
    // Image Gallery
    const thumbs = document.querySelectorAll('.product-gallery__thumb');
    const featuredImageWrapper = document.querySelector('.product-gallery__images');
    if (thumbs.length > 0 && featuredImageWrapper) {
      const imageGallery = new ImageGallery(thumbs, featuredImageWrapper);
    }

    new StockBadgeUI();
  });

  const savingsElement = document.querySelector('[data-flair-savings]');
  const discountAmountElement = document.querySelector('[data-flair-discount-amount]');
  document.addEventListener('product-variant:changed', (e) => {
    const variant = e.detail;
    const discountAmount = variant.compare_at_price - variant.price;
    
    if (discountAmount > 0) {
      discountAmountElement.textContent = formatCurrency(discountAmount);
      savingsElement.style.display = '';
    } else {
      savingsElement.style.display = 'none';
    }
  });

  /**
   * Converts numbers directly from pennies into standardized localized strings.
   * @param {number} cents - Calculated subtotal amounts.
   * @returns {string} Fully localized structural formats.
   */
  function formatCurrency(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-quantity-selector-bulk"] && !Shopify.designMode) return;
  try {
    class QuantitySelectorBulk {
		/**
		 * Instantiate QuantitySelectorBulk and discover elements.
		 * @param {HTMLElement} root - Parent root node containing data attributes.
		 */
		constructor(root) {
			this.root = root
			this.isBulk = Boolean(this.root.hasAttribute('data-can-bulk'));
			this.inputQuantity = document.querySelector('#quantity-variant-id');
			this.value = parseInt(this.inputQuantity.value);
			this.quantitySelectorPerEach = this.root.querySelector('[data-quantity-role="each"]');
			this.quantitySelectorPerBoxes = Array.from(this.root.querySelectorAll('[data-quantity-role="box"]'));
			this.quantitySelectorInputs = Array.from(
				this.root.querySelectorAll('[data-quantity-role="box"] input, [data-quantity-role="each"] input')
			);
			this.increaseButton = this.root.querySelectorAll('.ps-quantity-selector__btn-increase');
			this.decreaseButton = this.root.querySelectorAll('.ps-quantity-selector__btn-decrease');
			this.totalPriceElement = this.root.querySelector('.ps-quantity-selector__note-total-price');
			this.totalQuantityElement = this.root.querySelector('.ps-quantity-selector__note-total-quantity');
			this.totalSavingsElement = this.root.querySelector('.ps-quantity-selector__note-total-savings');

			this.price = parseInt(this.root.getAttribute('data-price')) || 0;
			this.compareAtPrice = parseInt(this.root.getAttribute('data-compare-at-price')) || 0;
			this.min = parseInt(this.inputQuantity.getAttribute('min')) || 0;
			this.max = parseInt(this.inputQuantity.getAttribute('max')) || 999;

			this.bind();
		}

		bind() {
			this.increaseButton.forEach(button => button.addEventListener('click', this.handleIncrease));
			this.decreaseButton.forEach(button => button.addEventListener('click', this.handleDecrease));
			this.quantitySelectorInputs.forEach(input => {
				input.addEventListener('change', this.handleInputChange)
				input.addEventListener('input', this.handleInputChange)
				input.addEventListener('click', this.selectAllText)
				input.addEventListener('focus', this.selectAllText)
			});
			document.addEventListener('product-variant:changed', this.handleVariantChange);
		}

		/**
		 * Hooks external variant switches to sync new prices back down into local item contexts.
		 * @param {CustomEvent} event - System emitted pricing payloads.
		 */
		handleVariantChange = (event) => {
			const variant = event?.detail;
			if (!variant || !variant.price) return;

			this.updateSelectedPrice(variant);
			this.renderVariantPrices();

			const hasVariant = this.hasVariantSelected(variant.id);
			this.toggleCard(hasVariant, variant.id);
			this.toggleLabel(hasVariant);
			this.reset(hasVariant);
		}

		/**
		 * Decrements internal quantity values by step boundaries.
		 * @param {MouseEvent} e - Click event from the decrement button.
		 */
		handleDecrease = (e) => {
			const input = e.target.closest('.ps-quantity-selector__controls').querySelector('[data-quantity-input]');
			const currentValue = parseInt(input.value) || 0;
			if (currentValue > this.min) {
				input.value = currentValue - 1;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			}
		}

		/**
		 * Increments internal quantity values by step boundaries.
		 * @param {MouseEvent} e - Click event from the increment button.
		 */
		handleIncrease = (e) => {
			const input = e.target.closest('.ps-quantity-selector__controls').querySelector('[data-quantity-input]');
			const currentValue = parseInt(input.value) || 0;
			if (currentValue < this.max) {
				input.value = currentValue + 1;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			}
		}

		/**
		 * Orchestrates sanitization checks when changes are fired inside input controls.
		 * Recalculates the aggregate quantity, clamps it to the allowed range, and syncs the hidden input.
		 * @param {Event} e - Input/change event from a quantity field.
		 */
		handleInputChange = (e) => {
			let value = 0;
			this.quantitySelectorInputs.forEach(input => {
				const quantityCard = input.closest('[data-quantity-role]');
				const boxSize = Number(quantityCard?.dataset.quantitySize || 1);
				const currentValue = parseInt(input.value || 0) * boxSize;
				value += currentValue;
			});

			if (isNaN(value) || value < this.min) {
				value = this.min;
			}
			
			if (value > this.max) {
				value = this.max;
			}

			this.value = value;

			this.setQuantity();
			if (this.isBulk) {
			  this.renderSubTotalPrice();
				this.renderNoteTotalPrice();
				this.renderNoteQuantity();
				this.renderNoteSavings();
			}

			this.dispatchQuantityChangeEvent(this.value);
		}

		/**
		 * Collects the active bulk discount tiers from box cards.
		 * @returns
		 * { {quantitySize: number, discountPercentage: number}[] } Sorted discount tier list.
		 */
		getDiscountTiers() {
			if (!this.isBulk) return [];

			return this.quantitySelectorPerBoxes
				.map((box) => ({
					quantitySize: Number(box.dataset.quantitySize || 0),
					discountPercentage: Number(box.dataset.discountPercentage || 0)
				}))
				.filter((tier) => tier.quantitySize > 0 && tier.discountPercentage > 0)
				.sort((a, b) => a.quantitySize - b.quantitySize);
		}

		/**
		 * Resolves the best matching discount percentage for the current quantity.
		 * @param {number} [quantity=this.value] - Quantity to evaluate against the tiers.
		 * @returns {number} Active discount percentage.
		 */
		getActiveDiscountPercentage(quantity = this.value) {
			if (!this.isBulk) return 0;

			const currentQuantity = Number(quantity || 0);
			const tiers = this.getDiscountTiers();
			let activeDiscount = 0;

			tiers.forEach((tier) => {
				if (currentQuantity >= tier.quantitySize) {
					activeDiscount = tier.discountPercentage;
				}
			});

			return activeDiscount;
		}

		/**
		 * Calculates the discounted unit price in cents.
		 * @param {number} [discountPercentage=this.getActiveDiscountPercentage()] - Discount percentage to apply.
		 * @returns {number} Discounted unit price in cents.
		 */
		getPriceDiscounted(discountPercentage = this.getActiveDiscountPercentage()) {
			const discountMultiplier = parseFloat((100 - discountPercentage) / 100);
			const price = (this.price * discountMultiplier) / 100;
			const finalPrice = parseFloat((Math.ceil(price * 100) / 100).toFixed(2)) * 100;

			return finalPrice;
		}

		/**
		 * Returns the current unit price in cents, with discount applied when eligible.
		 * @param {number} [quantity=this.value] - Quantity used to determine discount eligibility.
		 * @returns {number} Unit price in cents.
		 */
		getPrice(quantity = this.value) {
			const discountPercentage = this.getActiveDiscountPercentage(quantity);
			return discountPercentage > 0 ? this.getPriceDiscounted(discountPercentage) : this.price;
		}

		/**
		 * Converts a gross price in cents into an estimated GST-exclusive amount.
		 * @param {number} price - Gross price in cents.
		 * @returns {number} GST-exclusive amount in cents.
		 */
		getPriceGST(price) {
			return Math.round(Number(price || 0) / 1.1);
		}

		/**
		 * Calculates total savings in cents for the current quantity.
		 * @param {number} [quantity=this.value] - Quantity used for savings calculation.
		 * @returns {number} Savings in cents.
		 */
		getSavings(quantity = this.value) {
			const currentQuantity = Number(quantity || 0);
			const discountPercentage = this.getActiveDiscountPercentage(currentQuantity);

			if (!discountPercentage || currentQuantity <= 0) {
				return 0;
			}

			const discountedUnitPrice = this.getPriceDiscounted(discountPercentage);
			const regularTotal = this.price * currentQuantity;
			const discountedTotal = discountedUnitPrice * currentQuantity;

			return Math.max(0, regularTotal - discountedTotal);
		}

		/**
		 * Mirrors the computed quantity into the hidden cart quantity input.
		 */
		setQuantity() {
			this.inputQuantity.value = this.value;
		}

		/**
		 * Synchronizes internal price state from the active variant payload.
		 * @param {Object} variant - Active product variant payload.
		 */
		updateSelectedPrice(variant) {
			this.price = Number(variant?.price || 0);
			this.compareAtPrice = Number(variant?.compare_at_price || 0);

			this.root.dataset.price = String(this.price);
			this.root.dataset.compareAtPrice = String(this.compareAtPrice);
		}

		/**
		 * Updates all visible price labels and GST labels in the selector.
		 */
		renderVariantPrices() {
			[this.quantitySelectorPerEach, ...this.quantitySelectorPerBoxes].forEach((container) => {
				const boxSize = Number(container.getAttribute('data-quantity-size') || 1);
				const discountPercentage = Number(container.getAttribute('data-discount-percentage') || null);
				const pricePerUnitDiscounted = this.getPriceDiscounted(discountPercentage);
				const pricePerBoxDiscounted = this.getPriceDiscounted(discountPercentage) * boxSize;
				const priceGST = this.getPriceGST(pricePerUnitDiscounted);

				const pricePerBoxDiscountedElement = container.querySelector('.ps-quantity-selector__price-per-box');
				if (pricePerBoxDiscountedElement) {
					pricePerBoxDiscountedElement.textContent = this.formatCurrency(pricePerBoxDiscounted);
				}

				const pricePerUnitDiscountedElement = container.querySelector('.ps-quantity-selector__price-per-unit');
				if (pricePerUnitDiscountedElement) {
					pricePerUnitDiscountedElement.textContent = this.formatCurrency(pricePerUnitDiscounted);
				}

				const priceGSTElement = container.querySelector('.ps-quantity-selector__price-gst span');
				if (priceGSTElement) {
					priceGSTElement.textContent = this.formatCurrency(priceGST);
				}
			})
		}

		/**
		 * Updates per-card subtotal prices in the DOM.
		 */
		renderSubTotalPrice() {
			const price = this.getPriceDiscounted(this.getActiveDiscountPercentage());

			[this.quantitySelectorPerEach, ...this.quantitySelectorPerBoxes].forEach((container) => {
				if (!container) return;

				const amount = Number.parseInt(container.querySelector('input')?.value || 0, 10);
				const size = Number(container.dataset.quantitySize || 1);
				const total = price * amount * size;

				container.querySelector('.ps-quantity-selector__sub-total-price').textContent = this.formatCurrency(total);
			});
		}

		/**
		 * Calculates structural subtotals and injects translated currency values into DOM.
		 */
		renderNoteTotalPrice() {
			const quantity = parseInt(this.value) || 0;
			const total = (this.getPrice() || 0) * quantity;
			// console.log('[QuantitySelectorBulk] getPrice()', this.getPrice(), 'quantity:', quantity, 'discount:', this.getActiveDiscountPercentage());
			
			this.totalPriceElement.textContent = this.formatCurrency(total);
		}

		/**
		 * Updates the bulk note with the current total quantity.
		 */
		renderNoteQuantity() {
			this.totalQuantityElement.textContent = this.value;
		}

		/**
		 * Updates the bulk note with the current savings amount and active discount label.
		 */
		renderNoteSavings() {
			const savingsAmount = this.getSavings();
			if (savingsAmount > 0) {
				this.totalSavingsElement.textContent = this.formatCurrency(savingsAmount) + ` (${this.getActiveDiscountPercentage()}%)`;
			} else {
				this.totalSavingsElement.textContent = this.formatCurrency(savingsAmount);
			}
		}

		/**
		 * Normalizes the `data-variant-selected` payload into an array of variant ids.
		 * @param {string} value - Raw attribute value.
		 * @returns {string[]} Parsed variant id list.
		 */
		parseVariantSelected(value) {
			if (!value) return [];

			try {
				const parsed = JSON.parse(value);
				return Array.isArray(parsed) ? parsed.map(String) : [String(parsed)];
			} catch (error) {
				return String(value)
					.replace(/^\[/, '')
					.replace(/\]$/, '')
					.split(',')
					.map(item => item.trim().replace(/^"|"$/g, ''))
					.filter(Boolean);
			}
		}

		/**
		 * Checks whether the active variant exists in any bulk card selection list.
		 * @param {string|number} variantId - Active variant id.
		 * @returns {boolean} True when at least one bulk card matches the variant.
		 */
		hasVariantSelected(variantId) {
			const currentVariantId = String(variantId || '');

			return this.quantitySelectorPerBoxes.some((box) => {
				const selectedVariants = this.parseVariantSelected(box.dataset.variantSelected);
				return selectedVariants.includes(currentVariantId);
			});
		}

		/**
		 * Shows or hides the bulk UI and filters visible box cards by the active variant.
		 * @param {boolean} show - Whether the bulk UI should be visible.
		 * @param {string|number} variantId - Active variant id.
		 */
		toggleCard(show, variantId) {
			const visible = Boolean(show);
			const currentVariantId = String(variantId || '');

			const title = this.root.querySelector('.ps-quantity-selector__title');
			if (title) {
				title.hidden = !visible;
			}

			if (this.root.querySelector('.ps-quantity-selector__note')) {
				this.root.querySelector('.ps-quantity-selector__note').hidden = !visible;
			}

			if (this.quantitySelectorPerEach) {
				this.quantitySelectorPerEach.classList.toggle('ps-quantity-selector__card', visible);
			}

			if (this.quantitySelectorPerEach.querySelector('.ps-quantity-selector__price-row')) {
				this.quantitySelectorPerEach.querySelector('.ps-quantity-selector__price-row').hidden = !visible;
			}

			if (this.quantitySelectorPerEach.querySelector('.ps-quantity-selector__total')) {
				this.quantitySelectorPerEach.querySelector('.ps-quantity-selector__total').hidden = !visible;
			}

			this.quantitySelectorPerBoxes.forEach((box) => {
				if (!visible) {
					box.hidden = true;
					return;
				}

				const selectedVariants = this.parseVariantSelected(box.dataset.variantSelected);
				box.hidden = !selectedVariants.includes(currentVariantId);
			});
		}

		/**
		 * Resets input values after a variant change.
		 * @param {boolean} isBulk - Whether the current variant supports bulk behavior.
		 */
		reset(isBulk) {
			const bulk = Boolean(isBulk);

			this.quantitySelectorInputs.forEach(input => {
				input.value = this.min;
				if (!bulk) {
					input.value = 1;
				}
			});

			this.handleInputChange();
		}

		/**
		 * Swaps the each-card label between bulk and normal wording.
		 * @param {boolean} isBulk - Whether the current variant supports bulk behavior.
		 */
		toggleLabel(isBulk){
			const bulk = Boolean(isBulk);
			const label = this.quantitySelectorPerEach.querySelector('.ps-quantity-selector__label');
			label.textContent = bulk ? label.dataset.text : 'Quantity:';
		}

		/**
		 * Selects the full value of the active input after focus/click.
		 * @param {FocusEvent|MouseEvent} e - Input interaction event.
		 */
		selectAllText = (e) => {
			setTimeout(() => {
				e.target?.select();
			}, 10);
		}

		/**
		 * Broadcasts a quantity change event for other product scripts.
		 * @param {number} total - New computed quantity.
		 */
		dispatchQuantityChangeEvent(total) {
			const event = new CustomEvent('product-quantity:changed', { detail: total });
			document.dispatchEvent(event);
		}

		/**
		 * Converts cents into a localized currency string.
		 * @param {number} cents - Amount in cents.
		 * @returns {string} Formatted currency string.
		 */
		formatCurrency(cents) {
			return new Intl.NumberFormat('en-US', {
				style: 'currency',
				currency: 'USD'
			}).format(cents / 100);
		}
	}

	/**
	 * Global dynamic lifecycle loader configuration.
	 */
	document.addEventListener('DOMContentLoaded', () => {
		/**
		 * Initializes every unmounted selector inside the provided DOM subtree.
		 * @param {ParentNode} container - Node to scan for selector roots.
		 */
		const initSelectors = (container = document) => {
			const selectors = container.querySelectorAll('[data-ps-quantity-selector-bulk]:not([data-quantity-selector-initialized])');
			selectors.forEach(selector => {
				new QuantitySelectorBulk(selector);
				selector.setAttribute('data-quantity-selector-initialized', 'true');
			});
		};

		initSelectors();

		/**
		 * Watches for dynamically inserted markup so new selectors are initialized automatically.
		 */
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				mutation.addedNodes.forEach((node) => {
					if (node.nodeType === Node.ELEMENT_NODE) {
						initSelectors(node.hasAttribute?.('data-ps-quantity-selector-bulk') ? node.parentNode : node);
					}
				});
			});
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	});
  } catch(e) { console.error(e); }
})();

})();
